import { LineItem } from '../LineItem';

const TYPE = 'ProposedShipment';

export type ConstructableProposedShipmentLineItem = Partial<LineItem> &
  Pick<ProposedShipmentLineItem, 'shipOrderId' | 'shipOrderLineItemId'>;

export class ProposedShipmentLineItem extends LineItem {
  id = undefined;
  shipOrderId: number;
  shipOrderLineItemId: number;

  constructor(opts: ConstructableProposedShipmentLineItem) {
    super(opts);
    this.type = TYPE;
    this.id = undefined;
    this.shipOrderId = opts.shipOrderId;
    this.shipOrderLineItemId = opts.shipOrderLineItemId;
    if (opts.childLineItems != null) {
      this.childLineItems = opts.childLineItems.map((val) => {
        if (!val.id) {
          throw new Error(
            'Invalid State - could not determine shiporder line item id',
          );
        }

        return new ProposedShipmentLineItem({
          ...val,
          shipOrderId: this.shipOrderId,
          shipOrderLineItemId: val.id,
        });
      });
    }
  }

  static isProposedShipmentLineItem(
    lineItem?: LineItem,
  ): lineItem is ProposedShipmentLineItem {
    return lineItem?.type === TYPE;
  }
}
